import React from 'react'
import {Modal} from 'react-bootstrap' 
import {toAbsoluteUrl} from '_metronic/helpers'

interface EnableDependabotModalProps {
  show: boolean
  onHide: () => void
  onRetry: () => void
  repositories: string[] 
}

const EnableDependabotModal: React.FC<EnableDependabotModalProps> = ({
  show,
  onHide,
  onRetry,
  repositories,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header className='p-5'>
        <Modal.Title>
          <div className='d-flex align-items-center '>
            <img
              src={toAbsoluteUrl('/media/integrations/github.svg')}
              alt='GitHub'
              className='me-3'
              style={{width: '30px'}}
            />
            Enable Dependabot Alerts
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='px-5 py-4'>
        <p>
          Dependabot alerts are disabled for the following repositories, which prevents SecureSlate
          from scanning for vulnerabilities:
        </p>
        <ul>
          {repositories.map((repo) => (
            <li key={repo}>
              <a
                href={`https://github.com/${repo}/settings/security_analysis`}
                target='_blank'
                rel='noopener noreferrer'
                style={{color: '#0E9F6E'}}
              >
                {repo}
              </a>
            </li>
          ))}
        </ul>
        <p>To enable Dependabot alerts, follow these steps for each repository:</p>
        <ol>
          <li>
            Go to the repository’s <strong>Settings</strong> tab on GitHub.
          </li>
          <li>
            Navigate to <strong>Code security and analysis</strong> under the Security section.
          </li>
          <li>
            Click <strong>Enable</strong> next to <strong>Dependabot alerts</strong>.
          </li>
          <li>Save the changes.</li>
        </ol>
        <p>
          For detailed instructions, refer to the{" "}
          <a
            href="https://docs.github.com/en/code-security/getting-started/dependabot-quickstart-guide"
            target="_blank"
            style={{color: '#0E9F6E'}}
            rel="noopener noreferrer"
          >
            Github Dependabot Quickstart Guide
          </a>.
        </p>
        <p>
          After enabling Dependabot alerts, click <strong>Retry Scan</strong> to continue.
        </p>
      </Modal.Body>
      <Modal.Footer className='m-0 px-4 py-2'>
        <button
            className='btn btn-sm btn-light fw-semibold me-4 fs-6'
            onClick={onHide}
            aria-label='Close'
            style={{height: '40px'}}
            >
            Cancel
        </button>
        <button
          type='submit'
          className='btn btn-sm fs-6'
          onClick={onRetry}
          style={{backgroundColor: '#0E9F6E', color: '#FFFFFF', height: '40px'}}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#148363')}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#0E9F6E')}
        >
          Retry Scan
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default EnableDependabotModal
